<template>
  <div>
    <van-nav-bar :title="personName" left-arrow @click-left="onClickLeft" />
    <van-card :desc="personCard" :title="personName">
      <div slot="thumb" style="width: 100%; height: 100%">
        <!-- <van-image width="100%" height="100%" :src="showPhotoUrl" /> -->
        <van-uploader v-model="fileList">
          <van-icon name="photograph" />
        </van-uploader>
      </div>
    </van-card>
    <van-form @submit="onBuildSubmit">
      <van-field
        readonly
        clickable
        name="picker"
        :value="typeLabel"
        label="住户类型"
        placeholder="点击选择住户类型"
        :default-index="typeIndex"
        @click="showTypePicker = true"
      />
      <van-popup v-model="showTypePicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="typeColumns"
          @confirm="onTypeConfirm"
          @cancel="showTypePicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="buildingLabel"
        label="楼栋"
        placeholder="点击选择楼栋"
        @click="showBuildPicker = true"
      />
      <van-popup v-model="showBuildPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="buildingLabel"
          :columns="buildColumns"
          @confirm="onBuildConfirm"
          @cancel="showBuildPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="unitLabel"
        label="单元"
        placeholder="点击选择单元"
        @click="showUnitPicker = true"
      />
      <van-popup v-model="showUnitPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="label"
          :columns="unitColumns"
          @confirm="onUnitConfirm"
          @cancel="showUnitPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="houseLabel"
        label="房间号"
        placeholder="点击选择房间号"
        @click="showHousePicker = true"
      />
      <van-popup v-model="showHousePicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="label"
          :columns="houseColumns"
          @confirm="onHouseConfirm"
          @cancel="showHousePicker = false"
        />
      </van-popup>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  data() {
    return {
      id: this.$route.query.id,
      personName: null,
      showPhotoUrl: null,
      personCard: null,
      // 住户类型
      typeLabel: null,
      typeId: null,
      typeColumns: [],
      showTypePicker: false,
      typeIndex: 0,
      // 楼栋
      buildingLabel: null,
      buildingId: null,
      buildColumns: [],
      showBuildPicker: false,
      // 单元
      unitLabel: null,
      unitId: null,
      unitColumns: [],
      showUnitPicker: false,
      // 房间号
      houseLabel: null,
      houseId: null,
      houseColumns: [],
      showHousePicker: false,
      fileList:[]
    };
  },
  mounted() {
    let that = this;
    let params = { communityId: this.$route.query.communityId };

    that
      .get("api-apmuc/personHouseRelationRest/byRIdDetail/", this.id)
      .then((res) => {
        that.personName = res.data.name;
        that.personCard = res.data.cardNo.replace(/(\w{1})\w*(\w{1})/, '$1**************$2');
        that.showPhotoUrl =
          that.$common.urlImage +
          res.data.showPhotoUrl +
          "?access_token=" +
          localStorage.getItem("token");
          this.fileList = [{url:this.showPhotoUrl}]
        let houseList = res.data.houseList[0];
        that
          .get("api-user/dict/listByCode?codes=", "FAMILY_TIES")
          .then((res) => {
            that.typeColumns = res.FAMILY_TIES;
            that.typeId = houseList.jtgxdm;
            that.typeColumns.map((item) => {
              if (that.typeId == item.code) {
                that.typeLabel = item.name;
              }
            });
          });
        that
          .post("api-apmuc/buildingRest/queryBuildingByCid", params)
          .then((res) => {
            that.buildColumns = res.data.buildingInfo;
            that.buildingId = houseList.buildingId;
            that.buildColumns.map((item) => {
              if (that.buildingId == item.buildingId) {
                that.buildingLabel = item.buildingLabel;
                let unitOptions = item.unitObjs;
                let s = [];
                unitOptions.map((item) => {
                  const child = {
                    value: item.dyName,
                    label: item.dyName + "单元",
                  };
                  s.push(child);
                });
                that.unitColumns = s;
                that.unitId = houseList.dyh;
                that.unitColumns.map((item) => {
                  if (that.unitId == item.value) {
                    that.unitLabel = item.label;
                  }
                });
              }
            });
          });
        let args = {
          buildingId: houseList.buildingId,
          communityId: that.$route.query.communityId,
          dyh: houseList.dyh,
        };
        that.post("api-apmuc/houseRest/queryHouses", args).then((res) => {
          const dataRooms = res.data;
          let roomOptions = [];
          dataRooms.map((item) => {
            const child = {
              label: item.roomNo + "室",
              value: item.id,
            };
            roomOptions.push(child);
          });
          that.houseColumns = roomOptions;
          that.houseId = houseList.houseId;
          that.houseColumns.map((item) => {
            if (that.houseId == item.value) {
              that.houseLabel = item.label;
            }
          });
        });
      });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onTypeConfirm(values) {
      this.typeLabel = values.name;
      this.typeId = values.code;
      this.showTypePicker = false;
    },
    onBuildConfirm(values) {
      this.buildingLabel = values.buildingLabel;
      this.buildingId = values.buildingId;
      let unitOptions = values.unitObjs;
      let s = [];
      unitOptions.map((item) => {
        const child = {
          value: item.dyName,
          label: item.dyName + "单元",
        };
        s.push(child);
      });
      this.unitColumns = s;
      this.showBuildPicker = false;
    },
    onUnitConfirm(values) {
      let that = this;
      this.unitLabel = values.label;
      this.unitId = values.value;
      this.showUnitPicker = false;
      let args = {
        buildingId: this.buildingId,
        communityId: this.$route.query.communityId,
        dyh: this.unitId,
      };
      that.post("api-apmuc/houseRest/queryHouses", args).then((res) => {
        const dataRooms = res.data;
        let roomOptions = [];
        dataRooms.map((item) => {
          const child = {
            label: item.roomNo + "室",
            value: item.id,
          };
          roomOptions.push(child);
        });
        that.houseColumns = roomOptions;
      });
    },
    onHouseConfirm(values) {
      this.houseLabel = values.label;
      this.houseId = values.value;
      this.showHousePicker = false;
    },
    onBuildSubmit() {
      if(this.fileList.length<=0){
        this.$toast('请选择照片');
        return;
      }
      console.log('=======', this.fileList)
      let that = this;
      that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });
      let editForm = {
        id: this.id,
        houseIdsStr: [this.houseId + "," + this.typeId],
      };
      if(this.fileList[0].content){
        editForm.showPhotoUrl = this.fileList[0].content
      }
      that
        .post(
          "api-apmuc/personHouseRelationRest/v2.0/updateMultiPersonHouseRelation",
          editForm
        )
        .then((res) => {
          that.$toast.clear();
          if (res.status == 0) {
            that.$toast({
              message: "修改成功！",
              type: "success",
              onClose: () => {
                that.$router.go(-1);
              },
            });
          } else {
            that.$toast.fail("修改失败");
          }
        });
    },
  },
};
</script>

<style scoped>
.van-card__content {
  min-height: 0;
  justify-content: center;
}
.van-uploader {
  width: 100%;
  height: 100%;
}
/deep/.van-uploader__input-wrapper{
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

/deep/ .van-uploader__preview{
  z-index: 99;
}
.van-uploader{
  border: 1px solid #eee;
  height: 80px;
  width: 80px;
}
.van-uploader__wrapper{
  position: relative;
}

</style>
